module.exports = __webpack_public_path__ + "img/alpha9.350d4a20.png";